import NotificationSettings from '@/models/NotificationSettings';

export default class NotificationRepository {
    public static getAll() {
        return NotificationSettings.query().withAll().first();
    }
}
